import { IState } from '../../../store';

export const selectExternalTourBannerImageUrl = (state: IState): string | null => {
  return state.offerData.tours?.externalTour?.tourBannerImageUrl || null;
};
